// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/balance_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { VoltageClass } from "./occto_master_model_pb";
import { file_bffuser_v1_occto_master_model } from "./occto_master_model_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/balance_model.proto.
 */
export const file_bffuser_v1_balance_model: GenFile = /*@__PURE__*/
  fileDesc("Ch5iZmZ1c2VyL3YxL2JhbGFuY2VfbW9kZWwucHJvdG8SCmJmZnVzZXIudjEi5gEKEkFyZWFDb2RlRGVtYW5kRGF0YRIoCglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRISCgpiYXNlX3NjYWxlGAMgASgBEhEKCWJhc2VfdGVtcBgEIAEoARIlCgVrb21hcxgFIAMoCzIWLmJmZnVzZXIudjEuRGVtYW5kS29tYRIVCg13ZWF0aGVyX2ljb25zGAYgAygJEi4KB3N1bW1hcnkYByABKAsyHS5iZmZ1c2VyLnYxLkRlbWFuZFBlYWtTdW1tYXJ5SgQIAhADUgtyZWdpb25fbmFtZSLfBgoKRGVtYW5kS29tYRIMCgR0aW1lGAEgASgJEhcKC2RlbWFuZF9wbGFuGAIgASgBQgIYARIaCg1kZW1hbmRfYWN0dWFsGAMgASgBSACIAQESJAoXZGVtYW5kX2FjdHVhbF9jb3JyZWN0ZWQYBCABKAFIAYgBARISCgpzb2xhcl9wbGFuGAUgASgBEhkKDHNvbGFyX2FjdHVhbBgGIAEoAUgCiAEBEhgKC3RlbXBlcmF0dXJlGAcgASgBSAOIAQESIQoUdGVtcGVyYXR1cmVfZm9yZWNhc3QYCCABKAFIBIgBARIWCglkZXdfcG9pbnQYCSABKAFIBYgBARIfChJkZXdfcG9pbnRfZm9yZWNhc3QYCiABKAFIBogBARIXCgp0cmVuZF9wbGFuGAsgASgBSAeIAQESHAoPcHJvY3VyZW1lbnRfbmV0GAwgASgBSAiIAQESHgoRZGVtYW5kX2V4dHJhX2hpZ2gYDSABKAFICYgBARIYCgtkZW1hbmRfaGlnaBgOIAEoAUgKiAEBEhcKCmRlbWFuZF9sb3cYDyABKAFIC4gBARIaCg1wcmVjaXBpdGF0aW9uGBAgASgBSAyIAQESHgoRZGVtYW5kX2Vycm9yX3JhdGUYESABKAFIDYgBARIeChFkZW1hbmRfcGxhbl92YWx1ZRgSIAEoAUgOiAEBEjoKGGF3YWl0aW5nX3ZvbHRhZ2VfY2xhc3NlcxgTIAMoDjIYLmJmZnVzZXIudjEuVm9sdGFnZUNsYXNzQhAKDl9kZW1hbmRfYWN0dWFsQhoKGF9kZW1hbmRfYWN0dWFsX2NvcnJlY3RlZEIPCg1fc29sYXJfYWN0dWFsQg4KDF90ZW1wZXJhdHVyZUIXChVfdGVtcGVyYXR1cmVfZm9yZWNhc3RCDAoKX2Rld19wb2ludEIVChNfZGV3X3BvaW50X2ZvcmVjYXN0Qg0KC190cmVuZF9wbGFuQhIKEF9wcm9jdXJlbWVudF9uZXRCFAoSX2RlbWFuZF9leHRyYV9oaWdoQg4KDF9kZW1hbmRfaGlnaEINCgtfZGVtYW5kX2xvd0IQCg5fcHJlY2lwaXRhdGlvbkIUChJfZGVtYW5kX2Vycm9yX3JhdGVCFAoSX2RlbWFuZF9wbGFuX3ZhbHVlIooHChBEZW1hbmREZXRhaWxLb21hEgwKBGtvbWEYASABKAUSDAoEdGltZRgCIAEoCRIXCgtkZW1hbmRfcGxhbhgDIAEoAUICGAESGgoNZGVtYW5kX2FjdHVhbBgEIAEoAUgAiAEBEhUKDWFjdHVhbF9zdGF0dXMYBSABKAkSJAoXZGVtYW5kX2FjdHVhbF9jb3JyZWN0ZWQYBiABKAFIAYgBARISCgpzb2xhcl9wbGFuGAcgASgBEhkKDHNvbGFyX2FjdHVhbBgIIAEoAUgCiAEBEhgKC3RlbXBlcmF0dXJlGAkgASgBSAOIAQESIQoUdGVtcGVyYXR1cmVfZm9yZWNhc3QYCiABKAFIBIgBARIWCglkZXdfcG9pbnQYCyABKAFIBYgBARIfChJkZXdfcG9pbnRfZm9yZWNhc3QYDCABKAFIBogBARIaCg1wcmVjaXBpdGF0aW9uGA0gASgBSAeIAQESFwoKdHJlbmRfcGxhbhgOIAEoAUgIiAEBEhwKD3Byb2N1cmVtZW50X25ldBgPIAEoAUgJiAEBEh4KEWRlbWFuZF9leHRyYV9oaWdoGBAgASgBSAqIAQESGAoLZGVtYW5kX2hpZ2gYESABKAFIC4gBARIXCgpkZW1hbmRfbG93GBIgASgBSAyIAQESHgoRZGVtYW5kX2Vycm9yX3JhdGUYEyABKAFIDYgBARIeChFkZW1hbmRfcGxhbl92YWx1ZRgUIAEoAUgOiAEBEjoKGGF3YWl0aW5nX3ZvbHRhZ2VfY2xhc3NlcxgVIAMoDjIYLmJmZnVzZXIudjEuVm9sdGFnZUNsYXNzQhAKDl9kZW1hbmRfYWN0dWFsQhoKGF9kZW1hbmRfYWN0dWFsX2NvcnJlY3RlZEIPCg1fc29sYXJfYWN0dWFsQg4KDF90ZW1wZXJhdHVyZUIXChVfdGVtcGVyYXR1cmVfZm9yZWNhc3RCDAoKX2Rld19wb2ludEIVChNfZGV3X3BvaW50X2ZvcmVjYXN0QhAKDl9wcmVjaXBpdGF0aW9uQg0KC190cmVuZF9wbGFuQhIKEF9wcm9jdXJlbWVudF9uZXRCFAoSX2RlbWFuZF9leHRyYV9oaWdoQg4KDF9kZW1hbmRfaGlnaEINCgtfZGVtYW5kX2xvd0IUChJfZGVtYW5kX2Vycm9yX3JhdGVCFAoSX2RlbWFuZF9wbGFuX3ZhbHVlIpsCChFEZW1hbmRQZWFrU3VtbWFyeRISCgptYXhfYWN0dWFsGAEgASgBEhAKCG1heF90aW1lGAIgASgJEhAKCG1heF9rb21hGAMgASgFEhIKCm1pbl9hY3R1YWwYBSABKAESEAoIbWluX3RpbWUYBiABKAkSEAoIbWluX2tvbWEYByABKAVKBAgEEAVKBAgIEBBSCG1heF90ZW1wUghtaW5fdGVtcFIObWF4X3RlbXBfdmFsdWVSDW1heF90ZW1wX2hvdXJSDm1pbl90ZW1wX3ZhbHVlUg1taW5fdGVtcF9ob3VyUg9pbWJhbGFuY2VfdG90YWxSE2ltYmFsYW5jZV9jb25maXJtZWRSEmltYmFsYW5jZV9mb3JlY2FzdCK2AQoORGVtYW5kQmdPcHRpb24SDwoHYmdfY29kZRgBIAEoCRIPCgdiZ19uYW1lGAIgASgJEi4KDGxpY2Vuc2VfdHlwZRgDIAEoDjIYLmJmZnR5cGVzLnYxLkxpY2Vuc2VUeXBlEjMKCXJldGFpbGVycxgEIAMoCzIgLmJmZnVzZXIudjEuRGVtYW5kUmV0YWlsZXJPcHRpb24SHQoVaW5jbHVkZXNfdW5hdHRyaWJ1dGVkGAUgASgIIkQKFERlbWFuZFJldGFpbGVyT3B0aW9uEhUKDWJ1c2luZXNzX2NvZGUYASABKAkSFQoNYnVzaW5lc3NfbmFtZRgCIAEoCSLMAQoQR2VuZXJhdGlvbkJnRGF0YRIoCglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRIPCgdiZ19jb2RlGAIgASgJEg8KB2JnX25hbWUYAyABKAkSKQoFa29tYXMYBCADKAsyGi5iZmZ1c2VyLnYxLkdlbmVyYXRpb25Lb21hEhQKDGZpbGxlZF9rb21hcxgFIAMoBRIUCgxyZXZpZXdfa29tYXMYBiADKAUSFQoNbWlzc2luZ19rb21hcxgHIAMoBSKGAQoZR2VuZXJhdGlvblNvdXJjZUJyZWFrZG93bhI1Cgtzb3VyY2VfdHlwZRgBIAEoDjIgLmJmZnVzZXIudjEuR2VuZXJhdGlvblNvdXJjZVR5cGUSKAoFdmFsdWUYAiABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSACIAQFCCAoGX3ZhbHVlIvMECg5HZW5lcmF0aW9uS29tYRIMCgR0aW1lGAEgASgJEisKCGdlbl9wbGFuGAIgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbEgAiAEBEi0KCmdlbl9hY3R1YWwYAyABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSAGIAQESLgoHdGhlcm1hbBgEIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWxCAhgBSAKIAQESLAoFc29sYXIYBSABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsQgIYAUgDiAEBEisKBHdpbmQYBiABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsQgIYAUgEiAEBEiwKBWh5ZHJvGAcgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbEICGAFIBYgBARIuCgdiaW9tYXNzGAggASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbEICGAFIBogBARIsCgVvdGhlchgJIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWxCAhgBSAeIAQESMQoOZ2VuX2Vycm9yX3JhdGUYCiABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSAiIAQESPwoQc291cmNlX2JyZWFrZG93bhgLIAMoCzIlLmJmZnVzZXIudjEuR2VuZXJhdGlvblNvdXJjZUJyZWFrZG93bkILCglfZ2VuX3BsYW5CDQoLX2dlbl9hY3R1YWxCCgoIX3RoZXJtYWxCCAoGX3NvbGFyQgcKBV93aW5kQggKBl9oeWRyb0IKCghfYmlvbWFzc0IICgZfb3RoZXJCEQoPX2dlbl9lcnJvcl9yYXRlItUBChNHZW5lcmF0aW9uUGxhbnREYXRhEigKCWFyZWFfY29kZRgBIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEhIKCnBsYW50X2NvZGUYAiABKAkSEgoKcGxhbnRfbmFtZRgDIAEoCRIpCgVrb21hcxgEIAMoCzIaLmJmZnVzZXIudjEuR2VuZXJhdGlvbktvbWESFAoMZmlsbGVkX2tvbWFzGAUgAygFEhQKDHJldmlld19rb21hcxgGIAMoBRIVCg1taXNzaW5nX2tvbWFzGAcgAygFKokDChRHZW5lcmF0aW9uU291cmNlVHlwZRImCiJHRU5FUkFUSU9OX1NPVVJDRV9UWVBFX1VOU1BFQ0lGSUVEEAASJwojR0VORVJBVElPTl9TT1VSQ0VfVFlQRV9DT0FMX1RIRVJNQUwQARImCiJHRU5FUkFUSU9OX1NPVVJDRV9UWVBFX0dBU19USEVSTUFMEAISJgoiR0VORVJBVElPTl9TT1VSQ0VfVFlQRV9PSUxfVEhFUk1BTBADEiIKHkdFTkVSQVRJT05fU09VUkNFX1RZUEVfTlVDTEVBUhAEEiAKHEdFTkVSQVRJT05fU09VUkNFX1RZUEVfU09MQVIQBRIfChtHRU5FUkFUSU9OX1NPVVJDRV9UWVBFX1dJTkQQBhIgChxHRU5FUkFUSU9OX1NPVVJDRV9UWVBFX0hZRFJPEAcSJQohR0VORVJBVElPTl9TT1VSQ0VfVFlQRV9HRU9USEVSTUFMEAgSIAocR0VORVJBVElPTl9TT1VSQ0VfVFlQRV9PVEhFUhAJQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bffuser_v1_occto_master_model, file_google_type_decimal]);

/**
 * @generated from message bffuser.v1.AreaCodeDemandData
 */
export type AreaCodeDemandData = Message<"bffuser.v1.AreaCodeDemandData"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: double base_scale = 3;
   */
  baseScale: number;

  /**
   * @generated from field: double base_temp = 4;
   */
  baseTemp: number;

  /**
   * @generated from field: repeated bffuser.v1.DemandKoma komas = 5;
   */
  komas: DemandKoma[];

  /**
   * @generated from field: repeated string weather_icons = 6;
   */
  weatherIcons: string[];

  /**
   * summary is this area's 需要ピーク, drawn as the card's MAX / MIN ピルバッジ
   * (doji-bg.md AC-BDB-002). Absent when the area has no 実績値 on the display
   * date, or every koma with a 実績値 is 低圧未着 (awaiting_voltage_classes
   * non-empty) — the card then omits the pill row instead of showing a 0 peak.
   *
   * @generated from field: bffuser.v1.DemandPeakSummary summary = 7;
   */
  summary?: DemandPeakSummary;
};

/**
 * Describes the message bffuser.v1.AreaCodeDemandData.
 * Use `create(AreaCodeDemandDataSchema)` to create a new message.
 */
export const AreaCodeDemandDataSchema: GenMessage<AreaCodeDemandData> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 0);

/**
 * @generated from message bffuser.v1.DemandKoma
 */
export type DemandKoma = Message<"bffuser.v1.DemandKoma"> & {
  /**
   * @generated from field: string time = 1;
   */
  time: string;

  /**
   * Deprecated: 計画なし is flattened to 0 here; read demand_plan_value.
   * Kept for bundles that predate it — making this field optional instead
   * would hand them an absent value they dereference.
   *
   * @generated from field: double demand_plan = 2 [deprecated = true];
   * @deprecated
   */
  demandPlan: number;

  /**
   * @generated from field: optional double demand_actual = 3;
   */
  demandActual?: number;

  /**
   * demand_actual_corrected is the 実績値(補完) series: the stored 実績値 of a
   * 補完済み koma as-is (= demand_actual_koma.sending_end_kwh, the
   * post-imputation 需要端 value with the loss rate applied), NOT the portion
   * imputation contributed. Absent when the koma carries no imputed value
   * (= fill_method NULL, or no displayable 実績値). Equal to demand_actual on
   * imputed komas by construction — the series exists to mark WHICH komas are
   * imputed while keeping demand_actual continuous (doji-bg.md
   * §チャート系列「実績値(補完)」).
   *
   * @generated from field: optional double demand_actual_corrected = 4;
   */
  demandActualCorrected?: number;

  /**
   * @generated from field: double solar_plan = 5;
   */
  solarPlan: number;

  /**
   * @generated from field: optional double solar_actual = 6;
   */
  solarActual?: number;

  /**
   * @generated from field: optional double temperature = 7;
   */
  temperature?: number;

  /**
   * @generated from field: optional double temperature_forecast = 8;
   */
  temperatureForecast?: number;

  /**
   * @generated from field: optional double dew_point = 9;
   */
  dewPoint?: number;

  /**
   * @generated from field: optional double dew_point_forecast = 10;
   */
  dewPointForecast?: number;

  /**
   * @generated from field: optional double trend_plan = 11;
   */
  trendPlan?: number;

  /**
   * @generated from field: optional double procurement_net = 12;
   */
  procurementNet?: number;

  /**
   * @generated from field: optional double demand_extra_high = 13;
   */
  demandExtraHigh?: number;

  /**
   * @generated from field: optional double demand_high = 14;
   */
  demandHigh?: number;

  /**
   * @generated from field: optional double demand_low = 15;
   */
  demandLow?: number;

  /**
   * @generated from field: optional double precipitation = 16;
   */
  precipitation?: number;

  /**
   * demand_error_rate is the backend-computed 誤差率(%); absent when it could
   * not be computed (no plan, no actual, or a zero plan) (#2001).
   *
   * @generated from field: optional double demand_error_rate = 17;
   */
  demandErrorRate?: number;

  /**
   * demand_plan_value is the 計画値; absent when the backend has none for the
   * koma (no accepted plan for the area/date, or a koma every accepted plan
   * left unfilled), so 計画なし is distinguishable from a 0 plan.
   *
   * @generated from field: optional double demand_plan_value = 18;
   */
  demandPlanValue?: number;

  /**
   * awaiting_voltage_classes lists the 電圧階級 this koma's actual is expected
   * to include but whose 速報 has not arrived yet (doji-bg.md 低圧未着, #9298).
   * Empty = 確定. While non-empty, the shown actual is the value without those
   * classes. Independent of actual_status (値の品質の軸): a koma can be
   * interpolated AND carry this mark. The only value it takes is
   * [VOLTAGE_CLASS_LOW]: the koma's 1110 has not arrived, the 低圧未着 of the
   * spec and the design (the only state name they define). A koma whose 0110
   * is missing while 1110 arrived does not wait and is not marked (the
   * completion judgment keeps its behavior from before the 低圧 gate). Whether
   * it should wait too, and its state name and display, await PdM / Des
   * confirmation.
   *
   * @generated from field: repeated bffuser.v1.VoltageClass awaiting_voltage_classes = 19;
   */
  awaitingVoltageClasses: VoltageClass[];
};

/**
 * Describes the message bffuser.v1.DemandKoma.
 * Use `create(DemandKomaSchema)` to create a new message.
 */
export const DemandKomaSchema: GenMessage<DemandKoma> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 1);

/**
 * @generated from message bffuser.v1.DemandDetailKoma
 */
export type DemandDetailKoma = Message<"bffuser.v1.DemandDetailKoma"> & {
  /**
   * @generated from field: int32 koma = 1;
   */
  koma: number;

  /**
   * @generated from field: string time = 2;
   */
  time: string;

  /**
   * Deprecated: 計画なし is flattened to 0 here; read demand_plan_value.
   * Kept for bundles that predate it — making this field optional instead
   * would hand them an absent value they dereference.
   *
   * @generated from field: double demand_plan = 3 [deprecated = true];
   * @deprecated
   */
  demandPlan: number;

  /**
   * @generated from field: optional double demand_actual = 4;
   */
  demandActual?: number;

  /**
   * @generated from field: string actual_status = 5;
   */
  actualStatus: string;

  /**
   * demand_actual_corrected is the 実績値(補完) series: the stored 実績値 of a
   * 補完済み koma as-is (= demand_actual_koma.sending_end_kwh, the
   * post-imputation 需要端 value with the loss rate applied), NOT the portion
   * imputation contributed. Absent when the koma carries no imputed value
   * (= fill_method NULL, or no displayable 実績値). Equal to demand_actual on
   * imputed komas by construction — the series exists to mark WHICH komas are
   * imputed while keeping demand_actual continuous (doji-bg.md
   * §チャート系列「実績値(補完)」).
   *
   * @generated from field: optional double demand_actual_corrected = 6;
   */
  demandActualCorrected?: number;

  /**
   * @generated from field: double solar_plan = 7;
   */
  solarPlan: number;

  /**
   * @generated from field: optional double solar_actual = 8;
   */
  solarActual?: number;

  /**
   * @generated from field: optional double temperature = 9;
   */
  temperature?: number;

  /**
   * @generated from field: optional double temperature_forecast = 10;
   */
  temperatureForecast?: number;

  /**
   * @generated from field: optional double dew_point = 11;
   */
  dewPoint?: number;

  /**
   * @generated from field: optional double dew_point_forecast = 12;
   */
  dewPointForecast?: number;

  /**
   * @generated from field: optional double precipitation = 13;
   */
  precipitation?: number;

  /**
   * @generated from field: optional double trend_plan = 14;
   */
  trendPlan?: number;

  /**
   * @generated from field: optional double procurement_net = 15;
   */
  procurementNet?: number;

  /**
   * @generated from field: optional double demand_extra_high = 16;
   */
  demandExtraHigh?: number;

  /**
   * @generated from field: optional double demand_high = 17;
   */
  demandHigh?: number;

  /**
   * @generated from field: optional double demand_low = 18;
   */
  demandLow?: number;

  /**
   * demand_error_rate is the backend-computed 誤差率(%); absent when it could
   * not be computed (no plan, no actual, or a zero plan) (#2001).
   *
   * @generated from field: optional double demand_error_rate = 19;
   */
  demandErrorRate?: number;

  /**
   * demand_plan_value is the 計画値; absent when the backend has none for the
   * koma (帰属不明, no accepted plan, an unfilled koma, a retailer without a
   * row), so 計画なし is distinguishable from a 0 plan.
   *
   * @generated from field: optional double demand_plan_value = 20;
   */
  demandPlanValue?: number;

  /**
   * awaiting_voltage_classes lists the 電圧階級 this koma's actual is expected
   * to include but whose 速報 has not arrived yet (doji-bg.md 低圧未着, #9298).
   * Empty = 確定. While non-empty, the shown actual is the value without those
   * classes. Independent of actual_status (値の品質の軸): a koma can be
   * interpolated AND carry this mark. The only value it takes is
   * [VOLTAGE_CLASS_LOW]: the koma's 1110 has not arrived, the 低圧未着 of the
   * spec and the design (the only state name they define). A koma whose 0110
   * is missing while 1110 arrived does not wait and is not marked (the
   * completion judgment keeps its behavior from before the 低圧 gate). Whether
   * it should wait too, and its state name and display, await PdM / Des
   * confirmation.
   *
   * @generated from field: repeated bffuser.v1.VoltageClass awaiting_voltage_classes = 21;
   */
  awaitingVoltageClasses: VoltageClass[];
};

/**
 * Describes the message bffuser.v1.DemandDetailKoma.
 * Use `create(DemandDetailKomaSchema)` to create a new message.
 */
export const DemandDetailKomaSchema: GenMessage<DemandDetailKoma> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 2);

/**
 * DemandPeakSummary carries the 需要ピーク (MAX/MIN) of one 実績系列: the peak
 * 実績値 and the koma it occurred at, for both ends. 低圧未着 komas
 * (awaiting_voltage_classes non-empty) are never the peak. Absent (message nil)
 * when the series carries no 実績値 at all (未来日 / 取込前) or every koma with a
 * 実績値 is 低圧未着 — the frontend renders 「—」 (詳細のサマリーバー) or omits
 * the pill row (一覧のカード) rather than 0.
 *
 * 詳細画面のサマリーバー (GetDemandDetailResponse.summary) と ダッシュボードの
 * カード (AreaCodeDemandData.summary、 doji-bg.md AC-BDB-002) が同じ形の値を
 * 要求するため 1 message を共用する (旧名 DemandDetailSummary から改名)。
 *
 * 気温 (4, 8..12) と インバランス (13..15) は本 message では扱わない:
 *   - 気温 / 天気アイコン: frontend が画面側で既に取得済みの実績気象
 *     (WeatherActualService) から合成する。 backend に気象 join は作らない
 *     ので永続的に未使用。
 *   - インバランス 3 値: spec 対象外 (doji-bg.md #1781 重要 drift #1 で確定、
 *     design からも撤去済み)。
 *
 * @generated from message bffuser.v1.DemandPeakSummary
 */
export type DemandPeakSummary = Message<"bffuser.v1.DemandPeakSummary"> & {
  /**
   * max_actual is the peak 需要実績値 (kWh, 送電端) of the day.
   *
   * @generated from field: double max_actual = 1;
   */
  maxActual: number;

  /**
   * max_time is the peak koma's start time in "HH:mm".
   *
   * @generated from field: string max_time = 2;
   */
  maxTime: string;

  /**
   * max_koma is the peak koma's 1-indexed slot number (1..48).
   *
   * @generated from field: int32 max_koma = 3;
   */
  maxKoma: number;

  /**
   * min_actual is the lowest 需要実績値 (kWh, 送電端) of the day.
   *
   * @generated from field: double min_actual = 5;
   */
  minActual: number;

  /**
   * min_time is the lowest koma's start time in "HH:mm".
   *
   * @generated from field: string min_time = 6;
   */
  minTime: string;

  /**
   * min_koma is the lowest koma's 1-indexed slot number (1..48).
   *
   * @generated from field: int32 min_koma = 7;
   */
  minKoma: number;
};

/**
 * Describes the message bffuser.v1.DemandPeakSummary.
 * Use `create(DemandPeakSummarySchema)` to create a new message.
 */
export const DemandPeakSummarySchema: GenMessage<DemandPeakSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 3);

/**
 * DemandBgOption mirrors internalapi.v1.DemandBgOption (see that message's
 * doc comment for the full contract) — the BFF handler passes it through
 * unchanged.
 *
 * @generated from message bffuser.v1.DemandBgOption
 */
export type DemandBgOption = Message<"bffuser.v1.DemandBgOption"> & {
  /**
   * @generated from field: string bg_code = 1;
   */
  bgCode: string;

  /**
   * @generated from field: string bg_name = 2;
   */
  bgName: string;

  /**
   * @generated from field: bfftypes.v1.LicenseType license_type = 3;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: repeated bffuser.v1.DemandRetailerOption retailers = 4;
   */
  retailers: DemandRetailerOption[];

  /**
   * includes_unattributed mirrors internalapi.v1.DemandBgOption.
   * includes_unattributed: this BG's 小売フィルター offers 帰属不明
   * (retailer_code "-UNK"); its BG 全体 actuals include it when the BG's
   * 構成小売 resolved (see the internalapi comment for the exception).
   *
   * @generated from field: bool includes_unattributed = 5;
   */
  includesUnattributed: boolean;
};

/**
 * Describes the message bffuser.v1.DemandBgOption.
 * Use `create(DemandBgOptionSchema)` to create a new message.
 */
export const DemandBgOptionSchema: GenMessage<DemandBgOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 4);

/**
 * DemandRetailerOption mirrors internalapi.v1.DemandRetailerOption.
 *
 * @generated from message bffuser.v1.DemandRetailerOption
 */
export type DemandRetailerOption = Message<"bffuser.v1.DemandRetailerOption"> & {
  /**
   * @generated from field: string business_code = 1;
   */
  businessCode: string;

  /**
   * @generated from field: string business_name = 2;
   */
  businessName: string;
};

/**
 * Describes the message bffuser.v1.DemandRetailerOption.
 * Use `create(DemandRetailerOptionSchema)` to create a new message.
 */
export const DemandRetailerOptionSchema: GenMessage<DemandRetailerOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 5);

/**
 * GenerationBgData is one generation BG's card on the 同時同量 発電 dashboard
 * (/balance/generation). The 48-koma actual series is aggregated from the
 * generation_actual_slot read-model with a power-source breakdown; gen_plan
 * is resolved by the backend from the latest plan_generation_value (#1999).
 *
 * @generated from message bffuser.v1.GenerationBgData
 */
export type GenerationBgData = Message<"bffuser.v1.GenerationBgData"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string bg_code = 2;
   */
  bgCode: string;

  /**
   * @generated from field: string bg_name = 3;
   */
  bgName: string;

  /**
   * @generated from field: repeated bffuser.v1.GenerationKoma komas = 4;
   */
  komas: GenerationKoma[];

  /**
   * filled_komas / review_komas / missing_komas are 1-based koma numbers (1..48)
   * flagged as provisional imputation / low-confidence imputation / total loss.
   *
   * @generated from field: repeated int32 filled_komas = 5;
   */
  filledKomas: number[];

  /**
   * @generated from field: repeated int32 review_komas = 6;
   */
  reviewKomas: number[];

  /**
   * @generated from field: repeated int32 missing_komas = 7;
   */
  missingKomas: number[];
};

/**
 * Describes the message bffuser.v1.GenerationBgData.
 * Use `create(GenerationBgDataSchema)` to create a new message.
 */
export const GenerationBgDataSchema: GenMessage<GenerationBgData> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 6);

/**
 * GenerationSourceBreakdown mirrors internalapi.v1.GenerationSourceBreakdown
 * (see that message's doc comment for the source_type/value invariant, why
 * it isn't protovalidate-enforced — this message is response-only and both
 * backend's and the BFF's protovalidate interceptors validate inbound
 * requests only — and why only the producer, not the frontend consumer, can
 * guarantee it).
 *
 * @generated from message bffuser.v1.GenerationSourceBreakdown
 */
export type GenerationSourceBreakdown = Message<"bffuser.v1.GenerationSourceBreakdown"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSourceType source_type = 1;
   */
  sourceType: GenerationSourceType;

  /**
   * @generated from field: optional google.type.Decimal value = 2;
   */
  value?: Decimal;
};

/**
 * Describes the message bffuser.v1.GenerationSourceBreakdown.
 * Use `create(GenerationSourceBreakdownSchema)` to create a new message.
 */
export const GenerationSourceBreakdownSchema: GenMessage<GenerationSourceBreakdown> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 7);

/**
 * GenerationKoma is one 30-minute koma of a generation BG's series. Values are
 * 送電端 kWh. An absent (nil) field distinguishes 未確定/欠損 from 0.
 *
 * @generated from message bffuser.v1.GenerationKoma
 */
export type GenerationKoma = Message<"bffuser.v1.GenerationKoma"> & {
  /**
   * @generated from field: string time = 1;
   */
  time: string;

  /**
   * @generated from field: optional google.type.Decimal gen_plan = 2;
   */
  genPlan?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal gen_actual = 3;
   */
  genActual?: Decimal;

  /**
   * Deprecated: superseded by source_breakdown below (#7537, HJKS 9 区分化—
   * a flat "thermal" bucket doesn't match the taxonomy and never distinguishes
   * 石炭/ガス/石油). Value is not set. thermal/solar/wind/hydro/biomass/other
   * (fields 4-9) can be hard-deleted + reserved once no consumer reads them —
   * not tracked by an issue yet; check callers of
   * GetThermal/GetSolar/.../GetOther before removing.
   *
   * @generated from field: optional google.type.Decimal thermal = 4 [deprecated = true];
   * @deprecated
   */
  thermal?: Decimal;

  /**
   * Deprecated: superseded by source_breakdown below (#7537). Value is not set.
   *
   * @generated from field: optional google.type.Decimal solar = 5 [deprecated = true];
   * @deprecated
   */
  solar?: Decimal;

  /**
   * Deprecated: superseded by source_breakdown below (#7537). Value is not set.
   *
   * @generated from field: optional google.type.Decimal wind = 6 [deprecated = true];
   * @deprecated
   */
  wind?: Decimal;

  /**
   * Deprecated: superseded by source_breakdown below (#7537). Value is not set.
   *
   * @generated from field: optional google.type.Decimal hydro = 7 [deprecated = true];
   * @deprecated
   */
  hydro?: Decimal;

  /**
   * Deprecated: superseded by source_breakdown below (#7537) — バイオマス is
   * folded into GENERATION_SOURCE_TYPE_OTHER under HJKS (it was never a
   * standalone HJKS category, conventions.md). Value is not set.
   *
   * @generated from field: optional google.type.Decimal biomass = 8 [deprecated = true];
   * @deprecated
   */
  biomass?: Decimal;

  /**
   * Deprecated: superseded by source_breakdown below (#7537). Value is not set.
   *
   * @generated from field: optional google.type.Decimal other = 9 [deprecated = true];
   * @deprecated
   */
  other?: Decimal;

  /**
   * gen_error_rate is the backend-computed 誤差率(%); absent when it could not
   * be computed (no plan, no actual, or a zero plan) (#1999).
   *
   * @generated from field: optional google.type.Decimal gen_error_rate = 10;
   */
  genErrorRate?: Decimal;

  /**
   * source_breakdown is the HJKS 9-区分 power-source breakdown (#7537); always
   * empty until #2807 (電源ユニットマスタ) lands (#1998). Max 9 entries, one
   * per GenerationSourceType (see GenerationSourceBreakdown's doc comment for
   * why this isn't protovalidate-enforced). Number / name must stay in sync
   * with the internalapi mirror (internalapi.v1.GenerationKoma).
   *
   * @generated from field: repeated bffuser.v1.GenerationSourceBreakdown source_breakdown = 11;
   */
  sourceBreakdown: GenerationSourceBreakdown[];
};

/**
 * Describes the message bffuser.v1.GenerationKoma.
 * Use `create(GenerationKomaSchema)` to create a new message.
 */
export const GenerationKomaSchema: GenMessage<GenerationKoma> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 8);

/**
 * GenerationPlantData mirrors internalapi.v1.GenerationPlantData for the
 * 発電所別画面 (/balance/generation-detail). Only gen_actual is populated in
 * GenerationKoma (#2000); gen_plan / gen_error_rate / power-source breakdown
 * are nil (residual: plant-level plan source is undecided, HJKS breakdown is
 * #1998 and BG-level only).
 *
 * @generated from message bffuser.v1.GenerationPlantData
 */
export type GenerationPlantData = Message<"bffuser.v1.GenerationPlantData"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string plant_code = 2;
   */
  plantCode: string;

  /**
   * @generated from field: string plant_name = 3;
   */
  plantName: string;

  /**
   * @generated from field: repeated bffuser.v1.GenerationKoma komas = 4;
   */
  komas: GenerationKoma[];

  /**
   * @generated from field: repeated int32 filled_komas = 5;
   */
  filledKomas: number[];

  /**
   * @generated from field: repeated int32 review_komas = 6;
   */
  reviewKomas: number[];

  /**
   * @generated from field: repeated int32 missing_komas = 7;
   */
  missingKomas: number[];
};

/**
 * Describes the message bffuser.v1.GenerationPlantData.
 * Use `create(GenerationPlantDataSchema)` to create a new message.
 */
export const GenerationPlantDataSchema: GenMessage<GenerationPlantData> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_model, 9);

/**
 * GenerationSourceType mirrors internalapi.v1.GenerationSourceType (wire
 * values identical); the BFF handler passes it through unchanged. See
 * internalapi.v1.GenerationSourceType for the HJKS taxonomy / bounded-context
 * rationale.
 *
 * @generated from enum bffuser.v1.GenerationSourceType
 */
export enum GenerationSourceType {
  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_COAL_THERMAL = 1;
   */
  COAL_THERMAL = 1,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_GAS_THERMAL = 2;
   */
  GAS_THERMAL = 2,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_OIL_THERMAL = 3;
   */
  OIL_THERMAL = 3,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_NUCLEAR = 4;
   */
  NUCLEAR = 4,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_SOLAR = 5;
   */
  SOLAR = 5,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_WIND = 6;
   */
  WIND = 6,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_HYDRO = 7;
   */
  HYDRO = 7,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_GEOTHERMAL = 8;
   */
  GEOTHERMAL = 8,

  /**
   * @generated from enum value: GENERATION_SOURCE_TYPE_OTHER = 9;
   */
  OTHER = 9,
}

/**
 * Describes the enum bffuser.v1.GenerationSourceType.
 */
export const GenerationSourceTypeSchema: GenEnum<GenerationSourceType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_balance_model, 0);

